export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500/8 via-accent-500/5 to-secondary-500/8 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-background-50 border border-background-200/60 flex items-center justify-center overflow-hidden shadow-lg shadow-primary-500/10">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20mobile%20phone%20with%20warm%20cozy%20screen%20displaying%20abstract%20cinematic%20content%2C%20soft%20glowing%20screen%20in%20dark%20environment%2C%20warm%20amber%20and%20golden%20accents%2C%20simple%20clean%20illustration%20style%2C%20app%20icon%20aesthetic%2C%20no%20text%20on%20screen&width=400&height=400&seq=app-icon-2026&orientation=squarish"
              alt="被窝网电影手机追剧"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              随时随地
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">手机追剧 · 被窝里的影院</h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5 max-w-lg">
              被窝网电影移动端完美适配，躺在床上就能畅享海量高清电视剧。支持离线缓存、画质切换、倍速播放，追剧体验不打折。无论通勤、午休还是睡前，打开被窝网电影，随时随地免费看全集。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                手机端访问
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-background-200/60 text-foreground-700 text-sm font-medium cursor-pointer hover:bg-background-300/60 transition-colors whitespace-nowrap">
                <i className="ri-qr-code-line"></i>
                扫码体验
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}